import { HttpClient, HttpClientRequest } from 'effect/unstable/http'
import type { FormConfig } from '@st/ui-config'
import { Cache, Context, Duration, Effect, Layer } from 'effect'
import { RuntimeConfig } from './runtime-config'

type FormConfigService = {
  get: (schemaId: string) => Effect.Effect<FormConfig | undefined>
}

export class FormConfigRepo extends Context.Service<FormConfigRepo, FormConfigService>()(
  'FormConfigRepo'
) {}

export function formConfigLiveLayer() {
  return Layer.effect(
    FormConfigRepo,
    Effect.gen(function* () {
      const http = yield* HttpClient.HttpClient
      const runtime = yield* RuntimeConfig
      const configBaseUrl = new URL('/config/form/', runtime.apiBaseUrl).toString()
      const configs = yield* Cache.make({
        capacity: 32,
        timeToLive: Duration.infinity,
        lookup: (schemaId: string) =>
          Effect.gen(function* () {
            const request = HttpClientRequest.get(configBaseUrl + encodeURIComponent(schemaId))
            const response = yield* http.execute(request)
            if (response.status != 200) {
              return yield* Effect.die(
                new Error(`Failed to load form config ${schemaId}: HTTP ${response.status}`)
              )
            }
            return (yield* response.json) as unknown as FormConfig
          }).pipe(Effect.orDie)
      })

      return { get: (schemaId) => Cache.get(configs, schemaId) }
    })
  )
}
